import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeaturedBeanCard = ({ bean, language }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate(`/bean-detail?id=${bean?.id}`);
  };

  // Get primary image or first image from images array
  console.log('Bean images for', bean?.nameEn, ':', bean?.images);
  const primaryImage = bean?.images?.find(img => img?.is_primary) || bean?.images?.[0];

  // Unique fallback images based on bean name
  const getFallbackImage = (beanName) => {
    const fallbacks = {
      'Ethiopian Yirgacheffe Grade 1': 'https://5.imimg.com/data5/SELLER/Default/2022/4/XP/WN/DQ/28816151/nescafe-coffee-beans-1-kg-pack.png',
      'Kenyan AA Nyeri': 'https://images.unsplash.com/photo-1511920170033-f8396924c348?w=800',
      'Uganda Robusta Screen 18': 'https://kunjaninaples.com/cdn/shop/files/kunjani-burundi-kayanza-gakenke-coffee-1_grande.jpg?v=1732658619',
      'Nigerian Plateau Arabica': 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=800',
      'Rwanda Bourbon Red Cherry': 'https://img.freepik.com/premium-psd/pile-coffee-beans-with-word-coffee-them_788415-4520.jpg?semt=ais_hybrid&w=740&q=80',
      'Tanzania Peaberry Kilimanjaro': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCOWVMiN_pd5L_T6hY5cOzcSyt05JJefMLYA&s',
      'Burundi Kayanza Natural': 'https://images.unsplash.com/photo-1587734195503-904fca47e0e9?w=800',
      'Ethiopian Sidamo Grade 2': 'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=800'
    };
    return fallbacks[beanName] || 'https://images.unsplash.com/photo-1447933601403-0c6688de566e';
  };

  const imageUrl = primaryImage?.image_url || getFallbackImage(bean?.nameEn);
  const imageAlt = language === 'en' ? primaryImage?.alt_text_en : primaryImage?.alt_text_zh;
  console.log('Primary image:', primaryImage, 'Final URL:', imageUrl);

  return (
    <div
      className="bg-card rounded-lg border border-border overflow-hidden shadow-card transition-smooth hover:shadow-modal"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative h-48 overflow-hidden">
        <Image
          src={imageUrl}
          alt={imageAlt || (language === 'en' ? bean?.nameEn : bean?.nameZh)}
          className="w-full h-full object-cover transition-smooth hover:scale-105"
        />
        <div className="absolute top-2 right-2 bg-card/90 backdrop-blur-sm px-3 py-1 rounded-full flex items-center gap-1">
          <span className="text-xs font-medium text-foreground">{language === 'en' ? bean?.country?.nameEn : bean?.country?.nameZh}</span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2 line-clamp-1">
          {language === 'en' ? bean?.nameEn : bean?.nameZh}
        </h3>

        <div className="flex items-center gap-2 mb-3">
          <div className="flex items-center gap-1 text-primary">
            <Icon name="DollarSign" size={16} />
            <span className="text-xl font-bold">{bean?.priceUsdPerKg?.toFixed(2)}</span>
          </div>
          <span className="text-sm text-muted-foreground">
            {language === 'en' ? '/kg' : '/公斤'}
          </span>
        </div>

        <div className="space-y-2 mb-4">
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="Calendar" size={14} className="text-muted-foreground" />
            <span>{language === 'en' ? 'Year:' : '年份:'} {bean?.productionYear}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="Package" size={14} className="text-muted-foreground" />
            <span className="capitalize">{bean?.processingType?.replace('_', ' ')}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="Award" size={14} className="text-muted-foreground" />
            <span>{language === 'en' ? 'Grade:' : '等级:'} {bean?.grade}</span>
          </div>
        </div>

        {isHovered && (
          <div className="space-y-2 mb-4 animate-in fade-in duration-200">
            <div className="flex items-center gap-2 text-sm text-foreground">
              <Icon name="Mountain" size={14} className="text-muted-foreground" />
              <span>{language === 'en' ? 'Altitude:' : '海拔:'} {bean?.altitudeM}m</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground">
              <Icon name="Droplet" size={14} className="text-muted-foreground" />
              <span>{language === 'en' ? 'Moisture:' : '水分:'} {bean?.moisturePct}%</span>
            </div>
          </div>
        )}

        <Button
          variant="default"
          fullWidth
          onClick={handleViewDetails}
          iconName="ArrowRight"
          iconPosition="right"
        >
          {language === 'en' ? 'View Details' : '查看详情'}
        </Button>
      </div>
    </div>
  );
};

export default FeaturedBeanCard;